import type { VoidFunctionComponent } from 'react';

import { LicenseTermFallbackDescription } from '../../../../../shared/licenses';
import { icons, IconText } from '../../../generic/Icon';
import type { IconType } from '../../../generic/Icon';
import type { SimpleLicenseTerm } from '../types';

type Props = {
  title: string;
  icon: IconType;
  terms: SimpleLicenseTerm[];
};

import styles from '../LicenseDrawer.module.less';

const TermItem: VoidFunctionComponent<SimpleLicenseTerm> = ({ termId, custom_description }) => {
  return (
    <div className={styles.termItem}>
      <div className={styles.termId}>
        {termId}
      </div>
      <div className={styles.termDescription}>
        {custom_description ?? LicenseTermFallbackDescription[termId]}
      </div>
    </div>
  );
};

const TermSection: VoidFunctionComponent<Props> = ({ title, icon, terms }) => {
  return (
    <div className={styles.termList}>
      <div className={styles.title}>
        <IconText icon={icons[icon]} text={title} />
      </div>
      {terms.length > 0 ? terms.map((term) => (
        <TermItem key={term.termId} {...term} />
      )) : <div className={styles.termItem}>No terms found.</div>}
    </div>
  );
};

export default TermSection;
